import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CheckFilled = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("g", { clipPath: 'url(#clip0_637_19235)' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0ZM12.3585 5.15146C12.166 4.95347 11.8495 4.94901 11.6515 5.1415L6.85714 9.80265L4.34854 7.36373C4.15055 7.17123 3.834 7.17569 3.6415 7.37368C3.44901 7.57168 3.45347 7.88823 3.65146 8.08072L6.5086 10.8585C6.70266 11.0472 7.01162 11.0472 7.20568 10.8585L12.3485 5.8585C12.5465 5.666 12.551 5.34945 12.3585 5.15146Z', fill: 'currentColor' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: 'clip0_637_19235' },
            React.createElement("rect", { width: '16', height: '16', fill: 'white' }))))); };

export { CheckFilled as default };
//# sourceMappingURL=CheckFilled.js.map
